import { getAPIPath, requestGooseAPI } from '../shared/request'
import type { ReceiptDto } from '../types/api'
import { CLIENT_RECEIPT_PATH } from '../types/constants'
import type { TBookingStep } from '../types/general'

export const ClientReceiptService = {
  getReceipt: async (locationName: string, orderId: string, step: TBookingStep): Promise<ReceiptDto> => {
    return requestGooseAPI<ReceiptDto>({
      url: getAPIPath(CLIENT_RECEIPT_PATH, { locationId: locationName, id: orderId }),
      method: 'GET',
      params: {
        step,
      },
    })
  },
}
